import { Link } from "react-router-dom";

const PropertyCard = ({ images, propertiesCount, address, ptitle, link }) => {
  const imageUrl =
    images?.length > 0 && images[0]?.path ? images[0].path : "/default-image.jpg";
  
  // Get the state from address
  const state = address?.state || "";

  return (
    <div className="card border-0 rounded-0 shadow-sm">
      <div
        className="position-relative image-container"
        style={{ height: "250px", overflow: "hidden", position: "relative" }}
      >
        <img
          src={imageUrl}
          alt={ptitle}
          className="card-img-top img-fluid"
          style={{ objectFit: "cover", height: "100%", width: "100%" }}
        />
        <span className="position-absolute top-0 start-0 m-3 badge text-white rounded-4 fw-bold px-3 py-2 shadow-sm bg-primary">
          {propertiesCount} PROPERTIES
        </span>
      </div>

      <div className="card-body p-4 text-start">
        <h5 className="card-title brand fw-bold mb-3">
          {state || "Unknown State"}
        </h5>
        {/* Pass state as URL parameter */}
        <Link 
          to={`/properties?state=${encodeURIComponent(state)}`} 
          className="text-primary text-decoration-none"
        >
          View Property <i className="bi bi-arrow-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default PropertyCard;